'use client';

import { useState } from 'react';
import useCart from '@/store/cart.store';
import { useSession } from 'next-auth/react';
import HeartIcon from '@/components/ui/icons/heart-icon';
import AuthModal from '@/components/ui/modals/auth-modal';
import { usePathname, useRouter } from '@/i18n/navigation';
import BurgerMenu from '@/components/ui/icons/burger-menu';
import HomeFixedIcon from '@/components/ui/icons/home-fixed-icon';
import CategoryFixedIcon from '@/components/ui/icons/category-fixed-icon';
import { useLocale } from 'use-intl';
import CartFixedBoxIcon from '@/components/icons/cart-fixed-box-icon';

const FixedBox = () => {
  const { push } = useRouter();
  const pathname = usePathname();
  const { data: session } = useSession();
  const [auth, setAuth] = useState(false);
  const state = useCart((state) => state);
  const locale = useLocale();
  return (
    <section className='fixed bottom-0 z-500 flex w-screen items-center justify-between bg-white px-3.5 py-3.5 lg:hidden'>
      <button
        onClick={() => push('/')}
        className={`flex flex-col items-center justify-center gap-1.5 ${pathname === '/' ? 'text-primary' : 'text-gray-700'}`}
      >
        <HomeFixedIcon className='size-4.5 sm:size-5' />
        <span className='text-xs font-bold sm:text-sm'>
          {locale === 'ar' ? 'الرئيسية' : 'Home'}
        </span>
      </button>
      <button
        onClick={() => push('/categories')}
        className={`flex flex-col items-center justify-center gap-1.5 cursor-pointer ${pathname === '/categories' ? 'text-primary' : 'text-gray-700'}`}
      >
        <CategoryFixedIcon className='size-4.5 sm:size-5' />
        <span className='text-xs font-bold sm:text-sm'>
          {locale === 'en' ? 'Categories' : 'الفئات'}
        </span>
      </button>
      <button
        onClick={() => push('/cart')}
        className={`relative flex size-12 items-center justify-center gap-1.5 rounded-full ${pathname === '/cart' ? 'text-primary border-primary border-2' : 'border border-gray-700 text-gray-700'}`}
      >
        <CartFixedBoxIcon className='size-6 sm:size-7' />
        {state?.cartItems?.length > 0 ? (
          <span className='bg-primary absolute end-0 -top-1.5 flex size-4.5 items-center justify-center rounded-full ps-0.5 pb-0.5 text-center text-[10px] text-white'>
            {state?.cartItems?.length || 0}
          </span>
        ) : null}
      </button>
      <button
        onClick={() => push(!session?.user ? '/favourite' : '/user/wishlist')}
        className={`flex flex-col items-center justify-center gap-1.5 ${pathname === '/favourite' || pathname === '/user/wishlist' ? 'text-primary' : 'text-gray-700'}`}
      >
        <HeartIcon className='size-4.5 sm:size-5' />
        <span className='text-xs font-bold sm:text-sm'>
          {locale === 'en' ? 'Favourites' : 'المفضلة'}
        </span>
      </button>
      <button
        onClick={() =>
          session?.user ? push('/user') : setAuth('login-mobile')
        }
        className={`flex flex-col items-center justify-center gap-1.5 ${pathname.includes('/user') && pathname !== '/user/wishlist' ? 'text-primary' : 'text-gray-700'}`}
      >
        <BurgerMenu className='size-4.5 sm:size-5' />
        <span className='text-xs font-bold sm:text-sm'>
          {locale === 'en' ? 'Account' : 'حسابى'}
        </span>
      </button>
      {auth ? <AuthModal auth={auth} setAuth={setAuth} /> : null}
    </section>
  );
};

export default FixedBox;
